export function getNestedProperty(
  obj: Record<string, unknown>,
  path: string
): unknown {
  // Parse the path to handle optional chaining (?.) and array notation ([0])
  const segments: string[] = [];
  let currentSegment = "";
  let i = 0;

  if (!obj) {
    return undefined;
  }

  // Empty path returns the original object
  if (path === "") {
    return obj;
  }

  while (i < path.length) {
    if (path[i] === "?" && path[i + 1] === ".") {
      // Handle optional chaining
      if (currentSegment) {
        segments.push(currentSegment);
        currentSegment = "";
      }
      i += 2; // Skip '?.'
    } else if (path[i] === ".") {
      // Handle regular dot notation
      if (currentSegment) {
        segments.push(currentSegment);
        currentSegment = "";
      }
      i++;
    } else if (path[i] === "[") {
      // Handle array bracket notation
      if (currentSegment) {
        segments.push(currentSegment);
        currentSegment = "";
      }
      i++; // Skip '['
      while (i < path.length && path[i] !== "]") {
        currentSegment += path[i];
        i++;
      }
      if (path[i] === "]") {
        segments.push(currentSegment);
        currentSegment = "";
        i++; // Skip ']'
      }
    } else {
      currentSegment += path[i];
      i++;
    }
  }

  // Don't forget the last segment
  if (currentSegment) {
    segments.push(currentSegment);
  }

  // Navigate through the object using the parsed segments
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return segments.reduce<any>((current, key) => {
    if (current === null || current === undefined) {
      return undefined;
    }

    // Check if the key is a number (array index)
    const numKey = Number(key);
    if (!isNaN(numKey) && Array.isArray(current)) {
      return current[numKey];
    }

    return current[key];
  }, obj);
}
